import { render, staticRenderFns } from "./LiquidationAuction.vue?vue&type=template&id=6d6b6c98&scoped=true&"
import script from "./LiquidationAuction.vue?vue&type=script&lang=js&"
export * from "./LiquidationAuction.vue?vue&type=script&lang=js&"
import style0 from "./LiquidationAuction.vue?vue&type=style&index=0&id=6d6b6c98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6b6c98",
  null
  
)

export default component.exports